// DeviceCTOValidation.jsx
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getDevice } from "../api/devices";
import { consoleFeatures } from "../config/consoleFeatures";


export default function DeviceCTOValidation() {
  const { id } = useParams();
  const [device, setDevice] = useState(null);
  const [error, setError] = useState("");
  const [caValid, setCaValid] = useState(null);
  
  const token = localStorage.getItem("token");

  useEffect(() => {
    async function loadDevice() {
      try {
        if (!token) throw new Error("Not logged in");

        const d = await getDevice(token, id);
        setDevice(d);

        if (d?.cto_bundle_json?.root_ca_pem) {
          validateRootCA(d.cto_bundle_json.root_ca_pem);
        } else {
          setCaValid(false);
        }
      } catch (err) {
        console.error(err);
        setError(err.message);
      }
    }

    loadDevice();
  }, [id, token]);

  const validateRootCA = (pem) => {
    const pemStr = pem.replace(/\n/g, "");
    const isValid =
      pemStr.startsWith("-----BEGIN CERTIFICATE-----") &&
      pemStr.endsWith("-----END CERTIFICATE-----");

    setCaValid(isValid);
  };

  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!device) return <p>Loading device...</p>;

  return (
    <div style={{ padding: "20px" }}>
      <h2>Device CTO Bundle Validation</h2>
      <h3>
        Device: {consoleFeatures.showDeviceName && device.name
          ? `${device.name} (${device.beid})`
          : device.beid}
      </h3>

      <h4>CTO Bundle JSON</h4>
      <pre>{JSON.stringify(device.cto_bundle_json, null, 2)}</pre>

      <h4>Root CA Validation</h4>
      {caValid === null && <p>Validating Root CA...</p>}
      {caValid === true && <p style={{ color: "green" }}>Root CA is valid ✅</p>}
      {caValid === false && <p style={{ color: "red" }}>Root CA is INVALID ❌</p>}

      <button
        style={{ marginTop: "20px" }}
        onClick={() => validateRootCA(device.cto_bundle_json.root_ca_pem)}
      >
        Re-validate Root CA
      </button>

    </div>
  );
}
